import isBlank from '@sedan-utils/is-blank';
import { capitalize } from 'lodash';
import { DateTime } from 'luxon';
import { createSelector } from 'reselect';

import { selectLocaleFormatter } from '../../../common/locale';

export const emptyOrFormatted = (value, formatter) => (isBlank(value) ? value : formatter({ value }));

const nonNumeric = /\D/gi;

export const selectAgGridColumnTypes = createSelector(selectLocaleFormatter, (formatters) => {
  return {
    Boolean: {
      valueFormatter: ({ value }) => capitalize(value)
    },
    Text: {
      valueFormatter: ({ value }) => value
    },
    Number: {
      valueFormatter: ({ value }) =>
        emptyOrFormatted(value, () => {
          const formattedNumber = formatters.number({ value });
          const isTruncated =
            parseFloat(value).toString().replace(nonNumeric, '') !== formattedNumber.replace(nonNumeric, '');

          return isTruncated ? `${formattedNumber}...` : formattedNumber;
        })
    },
    Year: {
      valueFormatter: ({ value }) => value
    },
    Percent: {
      valueFormatter: ({ value }) => emptyOrFormatted(value, formatters.percent)
    },
    Currency: {
      valueFormatter: ({ value }) => emptyOrFormatted(value, formatters.currency)
    },
    Period: {
      valueFormatter: ({ value }) => emptyOrFormatted(value, formatters.number)
    },
    Date: {
      valueFormatter: ({ value }) => {
        try {
          return formatters.date({ date: DateTime.fromSQL(value).toJSDate() });
        } catch (_e) {
          return value;
        }
      }
    }
  };
});
